__webpack_require__.p = "https://d3b4yo2b5lbfy.cloudfront.net/npg/live/";